var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeTextQrIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.5H16.5V7.125L10.875 1.5H1.5V16.5ZM1.5 18C1.08333 18 0.729167 17.8542 0.4375 17.5625C0.145833 17.2708 0 16.9167 0 16.5V1.5C0 1.08333 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08333 0 1.5 0H11.5L18 6.5V16.5C18 16.9167 17.8542 17.2708 17.5625 17.5625C17.2708 17.8542 16.9167 18 16.5 18H1.5ZM3.975 13.725H14.025V12.225H3.975V13.725ZM3.975 9.75H14.025V8.25H3.975V9.75ZM3.975 5.775H10.875V4.275H3.975V5.775ZM1.5 16.5V1.5V16.5Z",
    fill: "#AF4448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTextQrIcon);
export default __webpack_public_path__ + "static/media/FreeText_qr_icon.749743deb381f5d3123a46da5b291a9d.svg";
export { ForwardRef as ReactComponent };